// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"373":"30d4b277","453":"0f043c24","611":"6ed378af"}[chunkId] + ".chunk.js";
};